import { Box, Stack } from '@chakra-ui/react';
import DefaultLayout from '@components/layout/layout/DefaultLayout';
import { useAuthenticatedContextProvider } from '@contexts/AuthenticatedContextProvider';
import { InvalidLink } from './InvalidLink';
import { VerifyingLink } from './VerifyingLink';

const FsmVerify = () => {
  // Resources
  const { tokenStatus, handleResendLink } = useAuthenticatedContextProvider();
  const verifyingLink = !tokenStatus || tokenStatus === 'VALID';

  return (
    <DefaultLayout>
      <Box justifyContent="center" px={[6, 6, 10, 100]} border="10px solid" borderColor="teal">
        <Stack
          pt={['80px', '120px', '120px', 160]}
          pb={['80px', '240px', '240px', 240]}
          maxW="600px"
          minH={['480px', '480px', '720px']}
          mx="auto"
          spacing={6}
          alignItems="center"
          overflow="hidden"
          textAlign="center"
        >
          {verifyingLink ? <VerifyingLink /> : <InvalidLink handleResendLink={handleResendLink} status={tokenStatus} />}
        </Stack>
      </Box>
    </DefaultLayout>
  );
};

export default FsmVerify;
